// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

//富文本
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

import VueCropper from 'vue-cropper' 
Vue.use(VueCropper)

import router from './router'
import Vue from 'vue'
import App from './App.vue'



//引入公共js
import common from '../commonFunction/common'
Vue.prototype.common = common;

// import Vant from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Vant);

// 这个方法我没有亲测, 是查网上资料的, 不过我觉得, 放在`router.beforeEach`更好
router.afterEach((to,from,next) => {
    window.scrollTo(0,0);
    // 或
    // window.scroll(0, 0);
});

Vue.config.productionTip = false;
Vue.use(router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js